import React, { useEffect, useState } from 'react';
import { Col, Row, Space, Tag } from 'antd';
import numberHelper from '../../../../helpers/functions/number.helper';
import { FallOutlined, RiseOutlined, } from '@ant-design/icons';
import SaleChart from './sale_chart';

const SaleLayout = ({ total_date_breakdown_sales, total_sales, compare, park, }) => {
    return (
        <>
            <div style={{marginTop : 24,}}>
                <div>
                    <Row gutter={[12, 12]}>
                        <Col span={6} xs={12} sm={12} md={12} xl={6}>
                            <div style={{textAlign:'start',}}>
                                <div>
                                    <div>
                                        <span style={{color : 'var(--secondary-text-color)', fontWeight:500,}}>Sales Amount</span>
                                    </div>
                                    <div>
                                        <Space>
                                            <div>
                                                <span style={{ fontSize: 24, }}>{`${park?.currency?.symbol}${numberHelper?.commaNumber(total_sales?.sales_amount, 2)}`}</span>
                                            </div>
                                            <div>
                                                <Tag color={ compare?.sale_count_increased >= 0 ? 'green' : 'red' } style={{border:'none',}}>
                                                    {compare?.sale_count_increased >= 0 ? <RiseOutlined /> : <FallOutlined />}
                                                    <span>{`${numberHelper?.commaNumber((Math.abs(compare?.sale_amount_increased) * 100), 2)}%`}</span>
                                                </Tag>
                                            </div>
                                        </Space>
                                        
                                    </div>
                                </div>
                            </div>
                        </Col>
                        {/* <Col span={6} xs={12} sm={12} md={12} xl={6}>
                            <div style={{textAlign:'start',}}>
                                <div>
                                    <span style={{color : 'var(--secondary-text-color)', fontWeight:500,}}>Add On Amount</span>
                                </div>
                                <div>
                                    <Space>
                                        <div>
                                            <span style={{ fontSize: 24, }}>{`MYR${numberHelper?.commaNumber(total_sales?.add_on_amount, 2)}`}</span>
                                        </div>
                                        <div>
                                        <Tag color={ compare?.add_on_amount_increased >= 0 ? 'green' : 'red' } style={{border:'none',}}>
                                            {compare?.add_on_amount_increased >= 0 ? <RiseOutlined /> : <FallOutlined />}
                                            <span>{`${numberHelper?.commaNumber((Math.abs(compare?.add_on_amount_increased) * 100), 2)}%`}</span>
                                        </Tag>
                                        </div>
                                    </Space>
                                    
                                </div>
                            </div>
                        </Col> */}
                    </Row>
                </div>
                <div style={{marginTop:24,}}>
                    <SaleChart total_date_breakdown_sales={total_date_breakdown_sales} />
                </div>
            </div>
        </>
    );
}

export default SaleLayout;